import type { PollStatusResponse } from '../types';
import type { RequestFn } from '../client';

export class Poll {
  constructor(private readonly request: RequestFn) {}

  async getStatus(pollId: string): Promise<PollStatusResponse> {
    return this.request('GET', `/poll/status/${encodeURIComponent(pollId)}`);
  }
}
